.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rowGroup {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 44px; /* Fitts: comfortable tap target per UX §2.4 */
  padding: 4px 8px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  color: inherit;
  font-family: inherit;
}

.row:hover,
.row:focus-visible {
  background: var(--tuna-palette-action-hover);
}

.row:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.rowIcon {
  flex-shrink: 0;
  opacity: 0.7;
}

.chordName {
  font-weight: 500;
}

.spacer {
  flex-grow: 1;
}

.playButton {
  flex-shrink: 0;
}

.chevron {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--tuna-palette-text-secondary);
}

.rowDescription {
  padding: 0 8px 4px 32px;
}

.expandedBody {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 8px 8px 32px;
}

.line {
  display: block;
}

.sourceGlyphTheory,
.sourceGlyphAi {
  /* Intermediate-level glyph chip. Shape carries the signal (Σ vs sparkles);
     color is an accent only so the chip stays legible in monochrome themes. */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tuna-palette-text-secondary);
}

.sourceGlyphAi {
  /* Warm-leaning accent for the AI engine — mixed with text-secondary so
     contrast stays >= 3:1 against the panel background. */
  color: color-mix(in oklch, var(--tuna-palette-primary-main) 30%, var(--tuna-palette-text-secondary));
}

.source {
  /* Advanced-level full label — slightly more prominent than the intermediate hint. */
  color: var(--tuna-palette-text-secondary);
}

.emptyCell {
  text-align: center;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  color: var(--tuna-palette-text-secondary);
}

.emptyIcon {
  opacity: 0.5;
}
